import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { getUserFactoryId } from "../../../../index";
import { getUserOdata } from "./crud";
import _ from 'lodash';

/**
 * @interface
 */
const initialUserSlice = {
    listLoading: true,
    actionsLoading: false,
    error: null,
    totalCount: 0,
    entities: [],
    versions: [],
    selected: null,
    approvers: [],
    pagination: {
        page: 1,
        sizePerPage: 10
    },
    filters: {
        setor: -1,
        status: false,
        name: '',
        sap: '',
        email: '',
    },
}

export const callTypes = {
    list: 'list',
    select: 'select'
}

//
export const fetchUsers = createAsyncThunk(
    'user/fetchUsers',
    async (args, { rejectWithValue, getState }) => {
        const { pagination, filters } = getState().user;
        const filterOdata = {
            status: true,
            factoryId: getUserFactoryId()
        }
        
        // Status
        if (filters.status) {
            filterOdata.status = false
        }

        // Nome
        if (!_.isEmpty(filters.name)) {
            filterOdata.name = {
                contains: filters.name,
            }
        }

        // Sap
        if (!_.isEmpty(filters.sap)) {
            filterOdata.sap = {
                contains: filters.sap,
            }
        }

        // Email
        if (!_.isEmpty(filters.email)) {
            filterOdata.email = {
                contains: filters.email,
            }
        }
        //console.log('filter',filterOdata)
        if (!_.isEmpty(filters.systemRole)) {
           // console.log('filter',filterOdata)
            filterOdata.systemRole = {
                name: {contains: filters.systemRole}
            }
            //console.log(filterOdata)
        }

        // Departamento/Setor
        if (!_.isEmpty(filters.setor) && filters.setor.value > 0) {
            filterOdata.deparmentId = filters.setor.value
        }

        const response = await getUserOdata({
            filter: filterOdata,
            skip: (pagination.page - 1) * pagination.sizePerPage,
            top: pagination.sizePerPage,
            count: true,
        })

        if (response.status === 200) {
            return response.data
        }

        return rejectWithValue(response.data)
    }
)

export const fetchAllUsers = createAsyncThunk(
    'user/fetchUsers',
    async (args, { rejectWithValue, getState }) => {
        const { pagination, filters } = getState().user;
        const filterOdata = {
            status: true
        }
        
        // Status
        if (filters.status) {
            filterOdata.status = false
        }

        // Nome
        if (!_.isEmpty(filters.name)) {
            filterOdata.name = {
                contains: filters.name,
            }
        }

        // Sap
        if (!_.isEmpty(filters.sap)) {
            filterOdata.sap = {
                contains: filters.sap,
            }
        }

        // Email
        if (!_.isEmpty(filters.email)) {
            filterOdata.email = {
                contains: filters.email,
            }
        }
        //console.log('filter',filterOdata)
        if (!_.isEmpty(filters.systemRole)) {
           // console.log('filter',filterOdata)
            filterOdata.systemRole = {
                name: {contains: filters.systemRole}
            }
            //console.log(filterOdata)
        }

        // Departamento/Setor
        if (!_.isEmpty(filters.setor) && filters.setor.value > 0) {
            filterOdata.deparmentId = filters.setor.value
        }

        const response = await getUserOdata({
            filter: filterOdata,
            skip: (pagination.page - 1) * pagination.sizePerPage,
            top: pagination.sizePerPage,
            count: true,
        })

        if (response.status === 200) {
            return response.data
        }

        return rejectWithValue(response.data)
    }
)

export const fetchUserById = createAsyncThunk('user/fetchUserById', 
    async ( userId, { rejectWithValue }) => {
        const response = await getUserOdata({ filter: { id: userId } });
        if ( response.status === 200 ) {
            return response.data;
        }
        rejectWithValue(response.data)
    }
)
export const fetchUserBySap = createAsyncThunk('user/fetchUserById', 
    async ( sap, { rejectWithValue }) => {
        const response = await getUserOdata({ filter: { Sap: sap } });
        if ( response.status === 200 ) {
            return response.data;
        }
        rejectWithValue(response.data)
    }
)

//
export const userSlice = createSlice({
    name: 'user',
    initialState: initialUserSlice,
    reducers: {
        //
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        //
        userFetched: (state, action) => {
            
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            console.log('teste')
            state.totalCount = totalCount;
        },
        approverFetched: (state, action) => {
            const { approvers } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.approvers = approvers;
        },
        //
        //
        //
        setPagination: (state, action) => {
            state.pagination.page = action.payload.page;
            state.pagination.sizePerPage = action.payload.sizePerPage;
        },
        setFilters: (state, action) => {
            state.filters = {
                ...state.filters,
                ...action.payload
            }
            state.listLoading = true;
        }
    }, extraReducers: (build) => {
        build.addCase(fetchUsers.fulfilled, (state, action) => {
           // console.log('teste2',action)
            state.entities = action.payload.value;
            state.totalCount = action.payload._count;
            state.listLoading = false;
           // console.log('teste3',state.entities)
        }).addCase(fetchUsers.rejected, (state, action) => {
            state.error = action.error.message
        })
        // Fetch user by id
        .addCase(fetchUserById.fulfilled, (state, action) => {
            state.selected = _.first(action.payload.value);
        })
    }
})

// Export all redux reducer
export const {
    setPagination,
    setFilters
} = userSlice.actions;

/**
 * Get the selector
 * @returns {{
 *  listLoading: boolean,
 *  actionsLoading: boolean,
 *  error: null,
 *  totalCount: Number,
 *  entities: [],
 *  versions: [],
 *  pagination: {
 *    page: Number,
 *    sizePerPage: Number
 *  },
 *  selected: null|import("./crud").User
 *  filters: {
 *  }
 * }}
 */
export const useUser = () => useSelector((state) => state.user);